import React from "react";
import {
  List,
  Datagrid,
  TextField,
  EmailField,
  NumberField,
} from "react-admin";
import { TimeField } from "../../components/common/TimeField";
import UserQueryFilter from "./UserQueryFilter";

import { UserInfo } from "../../components/common/UserInfo";

export const UserQueryList = (props) => (
  <List
    {...props}
    exporter={false}
    filters={<UserQueryFilter />}
    sort={{ field: "id", order: "DESC" }}
  >
    <Datagrid bulkActionButtons={false}>
      <TextField label="Id" source="id" />
      <UserInfo sortable={false} {...props} label="User Id" source="user_id" />
      {/* <TextField label="User Id" source="user_id" /> */}
      <TextField label="Query Type" source="type" />
      <TextField label="Query Message" source="message" />
      <TextField label="Resolved" source="resolved" />
      <EmailField label="Email" source="email" />
      <NumberField label="Phone" source="phone" />

      <TimeField label="Created" name={"Created on"} source="createdAt" />
      <TimeField label="Updated" name={"Updated on"} source="updatedAt" />
    </Datagrid>
  </List>
);
